import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Redirect mapping - tilføj gamle URLs og hvor de skal redirectes til
    const redirects = {
      // Eksempler på gamle sider der skal redirectes
      '/old-homepage': '/',
      '/services': '/tjenester',
      '/about': '/omos',
      '/about-us': '/omos',
      '/contact': '/kontakt',
      '/contact-us': '/kontakt',
      '/pricing': '/priser',
      '/prices': '/priser',
      '/portfolio': '/cases',
      '/work': '/cases',
      '/blog': '/artikler',
      '/news': '/artikler',
      '/seo-services': '/tjenester',
      '/web-design': '/tjenester',
      '/hjemmeside-priser': '/priser',
      '/seo-priser': '/priser',
      '/kontakt-os': '/kontakt',
      '/om-os': '/omos',
      
      // Gamle versioner af nuværende sider
      '/home': '/',
      '/index': '/',
      '/index.html': '/',
      '/index.php': '/',
      
      // SEO relaterede gamle sider
      '/seo-optimering': '/tjenester',
      '/seo-consultant': '/tjenester',
      '/google-ads': '/tjenester',
      
      // Gamle hjemmeside strukturer
      '/websites': '/tjenester',
      '/web-development': '/tjenester',
      '/responsive-design': '/tjenester',
      
      // Gamle kontakt strukturer
      '/get-in-touch': '/kontakt',
      '/reach-out': '/kontakt',
      '/hire-us': '/kontakt',
      
      // Gamle case strukturer
      '/projects': '/cases',
      '/our-work': '/cases',
      '/case-studies': '/cases',
      
      // Gamle pris strukturer
      '/cost': '/priser',
      '/quote': '/priser',
      '/estimate': '/priser',
      
      // Gamle URL'er fra tidligere hjemmeside (Google Console dublets)
      '/team': '/omos',
      '/marketing': '/tjenester',
      '/webdesign': '/tjenester',
      '/book-dit-mode': '/kontakt',
      '/vores-artikler': '/artikler/seo-guide-2025',
      
      // Gamle artikel URL'er
      '/artikler/hvad-er-en-behovsanalyse': '/artikler/seo-guide-2025',
      '/artikler/10-tips-til-din-seo': '/artikler/seo-guide-2025',
      '/artikler/lokal-seo': '/artikler/seo-guide-2025',
      '/artikler/hvad-er-seo': '/artikler/seo-guide-2025',
      
      // Gamle kunde case URL'er - redirect til hovedcases side
      '/kunder/psykolog-hagmund': '/cases',
      '/kunder/mayjoy': '/cases',
      '/kunder/psykologisk.info': '/cases',
      '/kunder/psykolog-kontakten': '/cases',
      '/kunder/lyngbypsykologen': '/cases',
      '/kunder/upcare.dk': '/cases',
      '/kunder/sejrklima': '/cases',
      '/kunder/psykudredning': '/cases',
      '/kunder/relationspsykologerne': '/cases'
    };

    // Check om nuværende sti skal redirectes
    if (redirects[currentPath]) {
      // Redirect med status kode information for SEO
      navigate(redirects[currentPath], { 
        replace: true,
        state: { from: currentPath, type: '301' }
      });
    }
  }, [location.pathname, navigate]);

  return null; // Denne komponent renderer intet
};

export default RedirectHandler;
